import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { getPopUpList } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import { useHistory } from 'react-router-dom';
import PopUpCard from '../../components/PopUpCard';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { useGetUser } from '../../hooks/useGetUser';




const PopUp = () => {
    const history = useHistory();
    const user = useGetUser();
    const [popUps, setPopUps] = useState([]);
    const [verMais, setVerMais] = useState(true);
    const [modalLoading, setModalLoading] = useState(false);
    const [filter, setFilter] = useState({ page: 1, pageSize: 10, query: "" });
    const [buscar, setBuscar] = useState('');

    const getPopUps = async () => {
        setModalLoading(true);
        const data = await getPopUpList(filter);
        setModalLoading(false);
        setPopUps(data.data);
    }

    useEffect(() => {
        (popUps && popUps.items?.length > 0 && popUps.page === popUps.totalPages) ? setVerMais(true) : setVerMais(false);
        getPopUps();
    }, [])

    const addPage = async () => {
        setModalLoading(true);
        const data = await getPopUpList(filter);
        setModalLoading(false);
        const f = filter;
        f.page += 1;
        setFilter(f);
        getPopUps([...popUps, ...data.data])
    }

    const findPopUps = async () => {
        const f = filter;
        f.query = buscar;
        f.page = 1;
        setFilter(f);
        const popUp = await getPopUpList(filter);
        getPopUps(popUp.data);
    }

    return (
        <>
            {(user.perfilAcesso === 'Master') && (
                <>
                    <div className={styles.wrapper}>
                        <div className={styles.title}>
                            Pop-Up
                        </div>
                        <div className={styles.buttonWrapper}>
                            <button className={`btnInvert ${styles.btAdd}`} onClick={() => { history.push('/pop-up/detalhe') }}>
                                Cadastrar Pop-Up
                            </button>
                        </div>
                        <div className={styles.subTitle}>
                            Pop-Ups cadastrados
                        </div>
                        <div className={styles.buscar}>
                            <FormControl>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setBuscar(e.target.value) }}
                                    label="Faça sua busca"
                                    value={buscar}
                                    variant="filled"
                                    className="customFilledInput"
                                    onKeyDown={
                                        (e) => {
                                            if (e.key === 'Enter') {
                                                findPopUps();
                                                e.preventDefault();
                                            }
                                        }
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <button onClick={findPopUps} className={styles.searcButton}>
                                                <FontAwesomeIcon icon={faSearch} />
                                            </button>
                                        )
                                    }}
                                />
                            </FormControl>
                        </div>
                        <div className={styles.acoesWrapper}>
                            {popUps && popUps.items?.map(
                                (p, index) => <PopUpCard key={index} popUp={p} />
                            )}
                        </div>
                        {
                            popUps.items?.length === 0 &&
                            <div className={styles.verMaisWrapper}> Não existem dados para exibir </div>
                        }
                        {verMais && (
                            <div className={styles.verMaisWrapper}>
                                <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                                    Ver mais
                                </button>
                            </div>
                        )}
                        <ModalLoading
                            open={modalLoading}
                            size="lg"
                        />
                    </div>
                </>
            )}

        </>
    );

}

export default PopUp;